export default __webpack_public_path__ + "static/media/Community.31760957.png";